module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_4.5eae97ba.png";